export enum NotificationType {
  Info = 1,
  Warning,
  Error,
  Success
}
